import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['species', 'breed']

  updateBreeds() {
    const species = this.speciesTarget.value

    if (!species) {
      return
    }

    fetch(`/pets/breeds?species=${species}`)
      .then((response) => response.json())
      .then((data) => {
        const breedSelect = this.breedTarget.tomselect
        breedSelect.clear()
        breedSelect.clearOptions()
        breedSelect.refreshOptions(false)

        data.breeds.forEach((breed) => {
          breedSelect.addOption({ value: breed, text: breed })
        })

        breedSelect.refreshOptions(false)
        breedSelect.setValue('')
      })
  }
}
